module.exports = __webpack_public_path__ + "img/favourites-empty.87057efe.svg";